import MyClaims from './MyClaims';

export default MyClaims;
